import { render, staticRenderFns } from "./periodicalEdit.vue?vue&type=template&id=60211710&scoped=true"
import script from "./periodicalEdit.vue?vue&type=script&lang=js"
export * from "./periodicalEdit.vue?vue&type=script&lang=js"
import style0 from "./periodicalEdit.vue?vue&type=style&index=0&id=60211710&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60211710",
  null
  
)

export default component.exports